import { Box, Tabs } from '@chakra-ui/react';
import type { SessionStore } from '@halo/chat-sdk-react';
import React from 'react';
import type { LuckyFormValues } from './LuckyForm';
import { LuckyForm } from './LuckyForm';

interface LuckyTabsProps {
  isGroup?: boolean;
  sessionStore?: SessionStore;
  onConfirm: (data: LuckyFormValues) => void;
}

// eslint-disable-next-line react-refresh/only-export-components
export enum LuckyType {
  Identical = '1',
  Random = '2',
  Exclusive = '3',
}

export function LuckyTabs({ isGroup, sessionStore, onConfirm }: LuckyTabsProps) {
  const [tabValue, setTabValue] = useState(LuckyType.Random);
  const { t } = useTranslation();
  const tabs = useMemo(() => {
    return [
      {
        value: LuckyType.Random,
        label: t('chat.random'),
        content: (
          <LuckyForm
            type={LuckyType.Random}
            isGroup={isGroup}
            sessionStore={sessionStore}
            onConfirm={onConfirm}
          />
        ),
      },
      {
        value: LuckyType.Identical,
        label: t('chat.identical'),
        content: (
          <LuckyForm
            type={LuckyType.Identical}
            isGroup={isGroup}
            sessionStore={sessionStore}
            onConfirm={onConfirm}
          />
        ),
      },
      // TOMO: Suspend exclusive
      // {
      //   value: LuckyType.Exclusive,
      //   label: 'Exclusive',
      //   content: (
      //     <LuckyForm
      //       type={LuckyType.Exclusive}
      //       isGroup={isGroup}
      //       sessionStore={sessionStore}
      //       onConfirm={onConfirm}
      //     />
      //   ),
      // },
    ];
  }, [isGroup, onConfirm, sessionStore, t]);

  return (
    <Box>
      <Box px="5" pb="2" fontSize="lg" fontWeight="semibold">
        {t('chat.luckyBoxToken')}
      </Box>
      <Tabs.Root
        size="sm"
        value={tabValue}
        onValueChange={(e) => setTabValue(e.value as LuckyType)}
      >
        <Tabs.List px="5" border="none" gap="6">
          {tabs.map((tab) => (
            <Tabs.Trigger
              value={tab.value}
              key={tab.value}
              _before={{ w: '3', margin: 'auto', background: 'fg' }}
              px="0"
            >
              {tab.label}
            </Tabs.Trigger>
          ))}
        </Tabs.List>

        {tabs.map((tab) => (
          <React.Fragment key={tab.value}>
            {tab.value === tabValue && (
              <Tabs.Content py="5" bg="bg.subtle" value={tab.value} key={tab.value}>
                {tab.content}
              </Tabs.Content>
            )}
          </React.Fragment>
        ))}
      </Tabs.Root>
    </Box>
  );
}
